import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Heading4 } from '@docon/docon-ui-library';
import { colors } from 'utilities/colorConfig';
import { emitEvent, isPeIosWebview } from 'utils/webview/webview';
import { useCookies } from 'react-cookie';
import { cookieNames } from 'utils/constants';

interface IProps {
  address?: string;
  className?: string;
}

const GetDirection = ({
  address = '',
  className,
  ...props
}: IProps) => {
  const saddr = useRef('');
  const [cookies, setCookies] = useCookies([cookieNames.VENDOR_COOKIE]);

  useEffect(() => {
    getLocation();
  }, []);

  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(setSaddr);
    }
  }

  function setSaddr(position) {
    saddr.current = `${position.coords.latitude},${position.coords.longitude}`;
  }

  function handleClick(event: any) {
    event.stopPropagation();
    if (isPeIosWebview(cookies[cookieNames.VENDOR_COOKIE], navigator?.userAgent)) {
      const directionUrl = `http://maps.google.com?saddr=${saddr.current}&daddr=${encodeURI(address)}`;
      const deeplink = `push.pharmeasy.clevertap://deeplink/open_url_in_browser?url=${directionUrl}`;
      emitEvent('onAction', {
        deeplink,
      });
    } else {
      window.open(`http://maps.google.com?saddr=${saddr.current}&daddr=${encodeURI(address)}`, '_blank');
    }
  }

  return (
    <Heading4
      color={colors.blueColor[1]}
      fontWeight={500}
      className={`${className}, clickable`}
      title={'Get Directions'}
      onClick={handleClick}
      {...props}
    />
  );

};

export default styled(GetDirection)``;
